/***
 Set of utils for tracking various events using dataLayer and GTM
 ***/

import DataLayerService from "datalayer-service/src/datalayer";
import {AccountAuthenticationAction, AccountAuthenticationUserType} from "datalayer-service/src/types/enums";

const dataLayerService = new DataLayerService(window);

export function trackLogin(type, accountType, hasTakenQuiz) {
  dataLayerService.accountAuthenticationEvent({
    action: AccountAuthenticationAction.LOGIN,
    authLevel: accountType,
    memberId: window.MEMBER_ID || "",
    userType: hasTakenQuiz ? AccountAuthenticationUserType.MEMBER : AccountAuthenticationUserType.ACCOUNT_HOLDER,
  });
}

export function trackObjectSave(model, slug) {
  if (model === 'mattress') {
    model = 'Model';
  } else if (model === 'store' || model === 'location') {
    model = 'Retail Location';
  } else {
    model = model.charAt(0).toUpperCase() + model.substr(1).toLowerCase();
  }

  dataLayerService.CTAClickEvent({
    category: 'favorite',
    subcategory: 'save',
    level: 'primary',
    pageRegion: model,
    product: {
      model: slug,
    }
  })
}

window.trackEnhancedProfileAds = function (objName) {
  const flashAds = $('.ad_container object');
  if (flashAds.length > 0) {
    flashAds.on('mousedown', function () {
      let adLoc = '';
      try {
        adLoc = $(this).parents('[id^="ad_"]').attr('id').split('_')[1];
      } catch (err) {
        adLoc = '';
      }
      dataLayerService.CTAClickEvent({
        category: 'ad',
        subcategory: 'click',
      })
    });
  }
};
